import React from 'react';
import Link from 'gatsby-link';
import MenuContainer from '../components/MenuContainer';
import Logo from '../icons/Logo.svg';
import Headroom from 'react-headroom';


const Header = ({ isCase }) => {

  return (

    <Headroom disableInlineStyles>
        <div className="header">
            <div className="header__wrapper">
                <div className="header__logo">
                    <Link to="/">
                        <Logo />
                    </Link>
                    <div className="header__info">
                        <Link to="/">
                            <span className="bold">Underdog.io Workplaces:</span> unsponsored documentary profiles of business and culture.
                         </Link>
                      </div>
                </div>
                <div className="header__nav">
                <Link className="btn" to="/">Workplaces</Link>
                <Link className="btn" to="/about">About</Link>
                </div>
            </div>
          </div>
      </Headroom>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.jsx